import Reveal from '@/components/base/Reveal';
import { timelineEvent, timelineStats } from '@/mocks/home';

export default function EventTimeline() {
  return (
    <section id="timeline" className="w-full bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <Reveal>
          <p className="flex items-center gap-2 text-sm font-medium text-primary-600">
            <span className="h-px w-8 bg-primary-500" />
            事件脉络
          </p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            一条时间线，看清争议是怎么走到今天的
          </h2>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-[1.5fr_1fr] lg:gap-12">
          <Reveal>
            <ol className="relative border-l border-background-200 pl-6 md:pl-8">
              {timelineEvent.nodes.map((node, i) => (
                <li key={node.time} className={i === timelineEvent.nodes.length - 1 ? '' : 'pb-8'}>
                  <span className="absolute -left-[7px] flex h-3.5 w-3.5 items-center justify-center">
                    <span
                      className={`block h-3.5 w-3.5 rounded-full border-2 border-background-50 ${
                        i === 0 ? 'bg-primary-500' : 'bg-secondary-400'
                      }`}
                    />
                  </span>
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="font-mono text-xs text-foreground-500">{node.time}</span>
                    <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-900">
                      {node.tag}
                    </span>
                  </div>
                  <h3 className="mt-2 font-heading text-lg font-semibold text-foreground-950">{node.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{node.desc}</p>
                </li>
              ))}
            </ol>
          </Reveal>

          <Reveal delay={120}>
            <div className="rounded-lg border border-background-200 bg-background-100/60 p-6 lg:sticky lg:top-24">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                <span className="block h-1.5 w-1.5 rounded-full bg-primary-500 animate-hly-pulse" />
                {timelineEvent.status}
              </span>
              <h3 className="mt-4 font-heading text-xl font-bold text-foreground-950">{timelineEvent.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{timelineEvent.summary}</p>

              <dl className="mt-6 grid grid-cols-3 gap-3 border-t border-background-200 pt-5">
                {timelineStats.map((stat) => (
                  <div key={stat.label}>
                    <dt className="text-xs text-foreground-500">{stat.label}</dt>
                    <dd className="mt-1 font-heading text-xl font-bold text-foreground-950">{stat.value}</dd>
                  </div>
                ))}
              </dl>

              <a
                href="#updates"
                className="mt-6 flex h-10 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 text-sm font-medium text-foreground-800 transition-colors hover:border-foreground-400"
              >
                <i className="ri-history-line text-base" />
                订阅该事件更新
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}